/* eslint-disable camelcase */
import React, { useState } from 'react'
import View from './view'
import useObjectState from '../../../hooks/useObjectState'
import orders from '../../../modules/orders'
import { useSelector } from 'react-redux'
import { setInitialState } from '../../../flux/cart'
import sumPrice from '../../../helpers/sumPrice'
import { activeLoading, hideLoading } from '../../../flux/loading'
import { dispatch } from '../../../store'
import { useHistory } from 'react-router-dom'
import validateForm from '../../../helpers/validateform'
import { functions } from '../../../modules/firebase'
import { taxPorcent } from '../../../config'
import useShippingCost from '../../../hooks/useShippingCost'
import objectDeleteNulls from '../../../helpers/objectDeleteNulls'

// import errorDictionary from './error_dictionary'

// const { validateCardNumber, validateCVC, validateExpiry } = window.OpenPay.card
const Checkout = props => {
  const doAdressAexist = JSON.parse(window.localStorage.getItem('address'))
  const shippingCost = useShippingCost()
  const shipping = doAdressAexist ? shippingCost : 0
  const history = useHistory()
  const itemsOncart = useSelector(state => state.cart)
  const [data, setData] = useObjectState({})
  // const [data, setData] = useObjectState(JSON.parse('{"name":"armando de jesus","lastname":"santiz lopez","date":"12 de febrero de 1996","email":"armandodejesus678@gmail.com","street_number":"calle san juan numero 87","suburb":"la centro","city":"san Cristobal de las casas","state":"chiapas","postal_code":"29247","number":"9671388451"}'))
  const [currentStep, setCurrenStep] = useState(0)
  const [input, setInputError] = useObjectState({ errors: [], message: null })
  const steps = ['Datos generales', 'Pagar']
  const subTotal = sumPrice(itemsOncart)
  const discountPercentage = 0.1 // Discount for online shopping
  const discountAmount = subTotal * discountPercentage;
  const tax = Math.ceil((subTotal + shipping) * (taxPorcent / 100))
  const totalPrice = subTotal - discountAmount + shipping + tax

  const onAnyInputChange = event => {
    setData({ [event.target.name]: event.target.value })
  }

  const goToStep = step => {
    setCurrenStep(step)
  }

  const successOperation = async ({ doAdressAexist = null, orderId, notific = null, id, successData = {}, metadata = {}, status }) => {
    await orders.success({ id, metadata, status, notific })
    await new Promise(resolve => setTimeout(resolve, 3000))
    endProcess()
    dispatch(setInitialState())
    history.push('/success', { doAdressAexist, totalPrice, subTotal, tax, items: itemsOncart, user: data, ...successData, methodPay: data.methodPay, orderId })
  }

  const failedOperation = async id => {
    await orders.failed(id)
    endProcess()
    setCurrenStep(1)
  }

  const saveOperation = async () => {
    startProcess()
    const result = await orders.create({
      ...data,
      subTotal,
      discountPercentage,
      discountAmount,
      shipping,
      totalPrice,
      tax,
      itemsOncart
    })
    return result
  }

  const handleNext = _event => {
    window.scrollTo(0, 0)

    if (currentStep === 0) {
      const requires = doAdressAexist
        ? ['email', 'name', 'lastname', 'street_number', 'suburb', 'city', 'state', 'number', 'postal_code', 'date']
        : ['email', 'name', 'lastname', 'date', 'number']
      const inputWidthErrors = validateForm.requires(data, requires)
      if (inputWidthErrors) setInputError({ errors: inputWidthErrors, message: 'Todos los campos son requeridos' })
      else if (!validateForm.validateEmail(data.email)) {
        setInputError({ errors: ['email'], message: 'El correo no es válido' })
      } else if (!!doAdressAexist && data.number.toString().length < 6) {
        setInputError({ errors: ['number'], message: 'El número de contacto no es válido' })
      } else setCurrenStep(currentStep + 1)
    }

    // if (currentStep === 1) {
    //   const requires = ['methodPay']
    //   const inputWidthErrors = validateForm.requires(data, requires)
    //   if (inputWidthErrors) return setInputError({ errors: inputWidthErrors, message: 'Porfavor selecciona un método de pago' })
    //   if (data.methodPay === 'card') return setCurrenStep(currentStep + 1)
    //   setCurrenStep(currentStep + 2)
    // }

    // if (currentStep === 2) {
    //   const inputsEmpties = validateForm.requires(data, ['card_year', 'card_month', 'card_number', 'card_cvv', 'card_name'])
    //   if (inputsEmpties) {
    //     return setInputError({ message: 'Todos los campos son requeridos', errors: inputsEmpties })
    //   }
    //   if (!validateCardNumber(data.card_number)) {
    //     return setInputError({
    //       errors: ['card_number'],
    //       message: 'El número de la tarjeta no es válido'
    //     })
    //   }
    //   if (!validateCVC(data.card_cvv)) {
    //     return setInputError({
    //       errors: ['card_cvv'],
    //       message: 'El código de seguridad no es válido'
    //     })
    //   }
    //   if (!validateExpiry(data.card_month, data.card_year)) {
    //     return setInputError({
    //       errors: ['card_month', 'card_year'],
    //       message: 'La fecha de vencimiento no es válida'
    //     })
    //   }
    //   return setCurrenStep(currentStep + 1)
    // }
  }

  const onAnyInputFocus = event => {
    const newErrors = input.errors.filter(error => (event.target.name || event.target.id) !== error)
    const NewErrorMessage = newErrors.length ? input.message : null
    setInputError({
      errors: newErrors,
      message: NewErrorMessage
    })
  }

  const handlePay = event => {
    // if (data.methodPay === 'card') return payWidthCard()
    // if (data.methodPay === 'cash') return payWithStore()
    // if (data.methodPay === 'spei') return payWithSpei()

    if (data.methodPay === 'cash') return depositWhitStore()
    if (data.methodPay === 'spei') return depositWhitSpei()
    setInputError({ ...input, message: 'Selecciona tu método de pago' })
  }

  const depositWhitStore = async () => {
    const { id, order_id } = await saveOperation()
    await successOperation({ id, orderId: order_id, notific: true, status: 'pending', doAdressAexist })
    sendMail(order_id)
  }

  const depositWhitSpei = async () => {
    const { id, order_id } = await saveOperation()
    await successOperation({ id, orderId: order_id, notific: true, status: 'pending', doAdressAexist })
    sendMail(order_id)
  }

  const sendMail = async (id) => {
    const address = objectDeleteNulls({
      streetNNumber: data.street_number,
      col: data.suburb,
      city: data.city,
      state: data.state,
      zip: data.postal_code
    })

    try {
      const data_ = {
        ...address,
        mailCost: shipping,
        birthdate: data.date,
        usermail: data.email,
        ulastname: data.lastname,
        ufirstname: data.name,
        order_id: id.toString(),
        products: itemsOncart.map(item => ({
          url: item.picture,
          name: item.title,
          price: item.price.toString(),
          qty: item.quantity
        }))
      }
      console.log(data_)
      await functions.httpsCallable('sendRecipeMail')(data_)
    } catch (error) {
      console.error('_error_', error)
    }
  }

  // const payWidthCard = () => {
  //   const deviceSessionId = window.OpenPay.deviceData.setup()
  //   startProcess()
  //   window.OpenPay.token.create({
  //     card_number: data.card_number,
  //     holder_name: data.card_name,
  //     expiration_year: data.card_year,
  //     expiration_month: data.card_month,
  //     cvv2: data.card_cvv
  //   },
  //   async response => {
  //     var { id: idCreated, path } = await saveOperation()
  //     try {
  //       const token = response.data.id
  //       var payStatus = await api.payouts.card({
  //         path,
  //         pId: idCreated,
  //         iva: tax,
  //         subtotal: subTotal.toString(),
  //         method: 'card',
  //         deviceId: deviceSessionId,
  //         description: 'checkout',
  //         token,
  //         name: data.card_name,
  //         phone: data.number,
  //         mail: data.email,
  //         amount: totalPrice.toString()
  //       })

  //       if (payStatus.error_code) {
  //         setInputError({ message: errorDictionary[payStatus.error_code] })
  //         failedOperation(idCreated)
  //       } else if (payStatus.charge) {
  //         successOperation({ notific: true, id: idCreated, metadata: response, status: 'payed' })
  //       }
  //     } catch (error) {
  //       setInputError({ message: 'No se pudo realizar el pago, intentalo nuevamente con otro método de pago' })
  //       failedOperation(idCreated)
  //     }
  //   },
  //   error => {
  //     console.log('error-----------------------------', error)
  //     setInputError({ message: 'Pago incorrecto, intentelo de nuevo' })
  //     setCurrenStep(1)
  //     endProcess()
  //   })
  // }

  // const payWithStore = async () => {
  //   var { id: idCreated, path } = await saveOperation()
  //   try {
  //     const response = await api.payouts.store({
  //       path,
  //       pId: idCreated,
  //       iva: tax,
  //       subtotal: subTotal.toString(),
  //       method: 'store',
  //       deviceId: window.OpenPay.deviceData.setup(),
  //       description: 'checkout',
  //       name: data.name,
  //       phone: data.number,
  //       mail: data.email,
  //       amount: totalPrice.toString()
  //     })
  //     if (!response.error_code) {
  //       return successOperation({ notific: true, id: idCreated, successData: response.charge, metadata: null, status: 'pending' })
  //     }
  //     failedOperation(idCreated)
  //     setInputError({ message: 'Error, intenta con un método diferente' })
  //   } catch (error) {
  //     failedOperation(idCreated)
  //     setInputError({ message: 'Error, intenta con un método diferente' })
  //   }
  // }

  // const payWithSpei = async () => {
  //   var { id: idCreated, path } = await saveOperation()
  //   try {
  //     const response = await api.payouts.spei({
  //       path,
  //       pId: idCreated,
  //       iva: tax,
  //       subtotal: subTotal.toString(),
  //       method: 'bank_account',
  //       deviceId: window.OpenPay.deviceData.setup(),
  //       description: 'checkout',
  //       name: data.name,
  //       phone: data.number,
  //       mail: data.email,
  //       amount: totalPrice.toString()
  //     })
  //     if (!response.error_code) {
  //       return successOperation({ notific: true, id: idCreated, successData: response.charge, metadata: null, status: 'pending' })
  //     }
  //     failedOperation(idCreated)
  //     setInputError({ message: 'Error, intenta con un método diferente' })
  //   } catch (error) {
  //     failedOperation(idCreated)
  //     setInputError({ message: 'Error, intenta con un método diferente' })
  //   }
  // }

  const startProcess = () => dispatch(activeLoading('Estamos procesando tu pago, porfavor espere un momento...'))
  const endProcess = () => dispatch(hideLoading())

  return (
    <View
      doAdressAexist={doAdressAexist}
      onFocus={onAnyInputFocus}
      startProcess={startProcess}
      endProcess={endProcess}
      data={data}
      state={data}
      onChange={onAnyInputChange}
      saveOperation={saveOperation}
      shipping={shipping}
      totalPrice={totalPrice}
      discountPercentage={discountPercentage}
      discountAmount={discountAmount}
      subTotal={subTotal}
      currentStep={currentStep}
      goToStep={goToStep}
      steps={steps}
      errors={input.errors}
      setErrors={setInputError}
      handleNext={handleNext}
      errorMessage={input.message}
      itemsOncart={itemsOncart}
      handlePay={handlePay}
      successOperation={successOperation}
      failedOperation={failedOperation}
      tax={tax}
    />
  )
}

export default Checkout
